module.exports = __webpack_public_path__ + "img/waiting-route.1e68e576.svg";